import { render, staticRenderFns } from "./PrjContainers.vue?vue&type=template&id=4fc145fd&"
import script from "./PrjContainers.vue?vue&type=script&lang=ts&"
export * from "./PrjContainers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports